import { Component, Input } from '@angular/core';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';
import { Aufteilungsschluessel } from '../../domain/model/datenabfrage/aufteilungsschluessel';

@Component({
    selector: 'tnb-datenabfrage-card-content',
    templateUrl: './datenabfrage-card-content.component.html',
    styleUrls: [
        './datenabfrage-card-content.component.scss',
    ],
    standalone: false,
})
export class DatenabfrageCardContentComponent {

    @Input() datenabfrage: Datenabfrage = null;
    @Input() aufteilungsSchluessels: Aufteilungsschluessel[] | [];

    constructor() {
    }

}
